<template>
    <POSuggestions></POSuggestions>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const POSuggestions = defineAsyncComponent(() =>
    import("../../components/Purchasing/POSuggestions/Table.vue")
);

export default {
    name: "PO_Suggestions", //The name you are in should not equal the name of the component you are importing.
    components: { POSuggestions, AuthLayout },
};
</script>
